import { Paragraph } from 'ui';
import { useTextCollapseExpand } from 'common/hooks';

type P = {
  description: string;
};

const ReadMoreText = ({ description }: P) => {
  const { collapseExpandButton, ellipsis } = useTextCollapseExpand({
    buttonTitles: { less: 'Read less', more: 'Read more' },
    rows: 4,
    text: description,
  });

  return (
    <div className="read-more-text">
      <div className="read-more-text__wrapper">
        <Paragraph ellipsis={ellipsis}>{description}</Paragraph>
        {collapseExpandButton}
      </div>
    </div>
  );
};

export default ReadMoreText;
